import { Toast } from '@readcloud/component-library';
import { Job } from '@readcloud/data';
import * as React from 'react';
import '../toasts.css';

interface IToastGeneratorProps {
  jobs: Record<string, Job>;
  onClose: (jobId: string) => void;
  timeout?: number;
}

export const ToastGenerator: React.FunctionComponent<IToastGeneratorProps> = (
  props
) => {
  return (
    <>
      {props.jobs &&
        Object.values(props.jobs).map((job) => {
          return (
            <Toast
              timeout={props.timeout || 2000}
              message={job.description}
              title={job.name}
              // what to do when timeout occurs
              onTimeout={() => props.onClose(job.id)}
              // what to do when user clicks close
              onClose={() => props.onClose(job.id)}
              key={job.id}
              rootElementId="centered-toast-root"
              rootClassName="centered-toast-root"
            ></Toast>
          );
        })}
    </>
  );
};
